(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panel = root.querySelector('.sxt-size-guide__panel');
    const backdrop = root.querySelector('.sxt-size-guide__backdrop');
    const trigger = root.querySelector('[data-sxt-size-open]');
    const kind = root.dataset.kind || 'clothing';
    const gender = root.dataset.gender || 'women';
    let lastFocus;

    const select = (name, value) => {
      panel.querySelectorAll(`[data-${name}-panel]`).forEach((el) => { el.hidden = el.dataset[`${name}Panel`] !== value; });
      panel.querySelectorAll(`[data-${name}-tab]`).forEach((el) => { const active = el.dataset[`${name}Tab`] === value; el.classList.toggle('is-active', active); el.setAttribute('aria-selected', active); });
    };
    const selectKind = (value) => {
      panel.querySelectorAll('[data-size-panel]').forEach((el) => { el.hidden = el.dataset.sizePanel !== value; });
      panel.querySelectorAll('[data-size-tab]').forEach((el) => { const active = el.dataset.sizeTab === value; el.classList.toggle('is-active', active); el.setAttribute('aria-selected', active); });
      select('gender', gender);
    };
    const media = document.querySelector('.product__media-wrapper');
    const close = () => { panel.hidden = true; backdrop.hidden = true; document.documentElement.classList.remove('sxt-modal-open'); if (media) media.inert = false; lastFocus?.focus(); };
    const open = () => { lastFocus = document.activeElement; if (panel.parentElement !== document.body) { document.body.append(backdrop, panel); } panel.hidden = false; backdrop.hidden = false; document.documentElement.classList.add('sxt-modal-open'); if (media) media.inert = true; selectKind(kind); panel.querySelector('.sxt-size-guide__close').focus(); };

    trigger.addEventListener('click', open);
    [backdrop, ...panel.querySelectorAll('[data-sxt-size-close]')].forEach((el) => el.addEventListener('click', close));
    panel.querySelectorAll('[data-size-tab]').forEach((el) => el.addEventListener('click', () => selectKind(el.dataset.sizeTab)));
    panel.querySelectorAll('[data-gender-tab]').forEach((el) => el.addEventListener('click', () => select('gender', el.dataset.genderTab)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) close(); });
  };
  const run = () => document.querySelectorAll('[data-sxt-size-guide]').forEach(init);
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
